import { useMemo } from 'react';
import moment from 'moment';

import { getPicTransactionCertificationTypeDisplay } from './certificationTypeDisplay';

const useParseResults = ({
  results,
  certificationTypeProgramName,
}: {
  results: any,
  certificationTypeProgramName?: ?string,
}) => {
  return useMemo(() => {
    return results?.length
      ? results.map((result) => {
          const parsedResult = { ...result };
          if (result.hasOwnProperty('certificationType')) {
            parsedResult.certificationType =
              getPicTransactionCertificationTypeDisplay(
                result.certificationType,
                certificationTypeProgramName,
              );
          }
          parsedResult.status = result.lastGeneratedAt
            ? `Generated at ${moment(result.lastGeneratedAt).format(
                'YYYY.MM.DD',
              )}`
            : '';
          return parsedResult;
        })
      : [];
  }, [results, certificationTypeProgramName]);
};

export default useParseResults;
